<template>
  <div class="hvh-table-container">
    <v-card elevation="3" class="hvh-card--rounded">
      <v-toolbar flat color="white">
        <v-toolbar-title class="hvh-table-title">{{ tableData.length }} Previous Runs</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat class="hvh-btn hvh-btn--primary" v-if="!hideNewRun" @click="$emit('new-run')">New Run</v-btn>
      </v-toolbar>
      <v-data-table :headers="headers" :items="tableData" :must-sort="true" :pagination.sync="pagination" :hide-actions="tableData.length <= 5" class="hvh-table">
        <template v-slot:items="props">
          <td>
            <span class="hvh-table-date">{{ dateFormatter(props.item.runDate) }}</span>
          </td>
          <td>
            <span class="hvh-table-date">{{ props.item.description }}</span>
          </td>
          <td>
            <span class="hvh-table-date">{{ dateFormatter(props.item.dataDate) }}</span>
          </td>
          <td>{{ props.item.cohortSize.toLocaleString('default') }}</td>
          <td class="text-xs-right">
            <v-btn flat class="hvh-txt-btn" @click="$emit('view', props.item)" v-right-click-menu="`/Analytics/CohortAnalyticRun/${props.item.id}/Result`">
              <v-icon left small class="mr-1">mdi-eye</v-icon>
              <span>View</span>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['tableData', 'dateFormatter','hideNewRun'],
  data() {
    return {
      headers: [
        {
          text: 'Run Date/Time',
          value: 'runDate',
          align: 'left',
          class: ['hvh-table-header']
        },
        {
          text: 'Details',
          value: 'details',
          align: 'left',
          class: ['hvh-table-header']
        },
        {
          text: 'Cohort Version',
          value: 'dataDate',
          align: 'left',
          class: ['hvh-table-header']
        },
        { text: 'Cohort Size', value: 'cohortSize', class: ['hvh-table-header'] },
        { text: '', value: '', sortable: false, align: 'right' }
      ],
      pagination: {
        descending: true,
        sortBy: 'runDate',
        page: 1,
        rowsPerPage: 5,
      }
    }
  }
};
</script>
